import { ISO4217 } from '@/utils/helpers/enums/Estoque';

const FormatMoney = {
  install(Vue) {
    Vue.filter('FormatMoney', (value, decimal = 2, curr = 'BRL') => {
      if (!value) {
        return 'N/I';
      }

      return new Intl.NumberFormat('pt-br', {
        style: 'currency',
        currency: curr.length <= 3 ? curr : ISO4217[curr],
        minimumFractionDigits: decimal,
      }).format(value);
    });
  },
};

export default FormatMoney;
